/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OtpType {
    LOGIN = 'Login',
    CHANGE_PASSWORD = 'ChangePassword',
    RESET_ACCOUNT = 'ResetAccount',
    FREEZE_ACCOUNT = 'FreezeAccount',
    UN_FREEZE_ACCOUNT = 'UnFreezeAccount',
    REGISTRATION_REQUEST = 'RegistrationRequest',
}
